module.exports = __webpack_public_path__ + "img/icon-question-blue.784df700.svg";